module.exports = __webpack_public_path__ + "img/ben.8d738ad9.png";